// @flow
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TextTruncate from 'react-text-truncate';
import LazyLoad from 'react-lazyload';
import I18n from '../../../i18n/I18n';
import CONFIG from '../../../config/';
import Helper from '../../../helper/Helper';
import styles from './ReservedBox.scss';

const ReservedBox = (props: Object) => {
  const item = props.item;
  const placeholder = (
    <img
      src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
      alt="placeholder"
    />
  );
  return (
    <div className={styles.ctr}>
      <div className={styles.flexer}>
        <div className={styles.imageNameWrapper}>
          {item && item.imagekey
            ? <div className={styles.imageCtr}>
                <LazyLoad height="100%" once placeholder={placeholder} offset={100}>
                  <img src={Helper.getTransformationUrl(item.imagekey)} />
                </LazyLoad>
              </div>
            : ''}
          <div className={styles.nameCtr}>
            {item && item.title
              ? <TextTruncate line={2} text={item.title} containerClassName={styles.productName} />
              : ''}
          </div>
        </div>
        <div className={styles.priceWrapper}>
          <h6 className={styles.attrTitle}>
            {I18n.getText('reserved.price', {}, 'Price')}
          </h6>
          {item && item.offer_price
            ? <div className={styles.attrVal}>
                {I18n.formatCurrency(Helper.formatPrice(item.offer_price, props.currencyCode))}
              </div>
            : ''}
        </div>
      </div>
      <div className={styles.attrCtr}>
        <div className={styles.eachAttr}>
          <h6 className={styles.attrTitle}>
            {I18n.getText('reserved.variant', {}, 'Variant')}
          </h6>
          {item
            ? <div className={styles.attrVal}>
                {item.variant || ''}
              </div>
            : ''}
        </div>
        <div className={styles.eachAttr}>
          <h6 className={styles.attrTitle}>
            {I18n.getText('reserved.sku', {}, 'SKU')}
          </h6>
          {item
            ? <div className={styles.attrVal}>
                {item.sku || ''}
              </div>
            : ''}
        </div>
        <div className={styles.eachAttr}>
          <h6 className={styles.attrTitle}>
            {I18n.getText('reserved.p-sku', {}, '	Partner SKU')}
          </h6>
          {item
            ? <div className={styles.attrVal}>
                {item.partner_sku || ''}
              </div>
            : ''}
        </div>
      </div>
    </div>
  );
};

ReservedBox.propTypes = {};

ReservedBox.getDefaultProps = {};

export default ReservedBox;



// WEBPACK FOOTER //
// ./src/components/orders/reservedBox/ReservedBox.js